module.exports = __webpack_public_path__ + "static/media/lazyaz_app1_preview.2e073eac.jpg";